import { css } from 'styled-components';

const theme = {
  colors: {
    primary: '#DC0023',
    black: '#000',
    darker: '#444',
    dark: '#636363',
    medium: '#9C9C9C',
    mediumLight: '#CFCFCF',
    light: '#EBEBEB',
    lighter: '#f1f1f1',
    white: '#FFFFFF',
    success: '#5A9114',
    warning: '#FA5A00',
    error: '#DC0023',
  },
  fonts: {
    default: 'Noto Sans',
  },
  fontSizes: {
    default: '14px',
    small: '12.5px',
    medium: '14px',
    large: '18px',
    smallTitle: '25px',
    largeTitle: '25px',
  },
  breakpoints: {
    tablet: '767px',
    desktop: '1023px',
    desktopLarge: '1200px',
  },
  grid: {
    unit: 'rem',
    gutter: '1',
    gutterVertical: '1',
  },
  transitions: {
    all: 'all ease-in-out 0.2s',
    transform: 'transform ease-in-out 0.2s',
  },
  shadows: {
    default: '0 5px 10px -2px rgba(0,0,0,0.3)',
    primaryFocus: '0 0 2px 2px rgba(179,27,52,0.5)',
  },
};

export default theme;

export const textRegular = css`
  font-family: ${theme.fonts.default};
  font-weight: 400;
`;

export const textBold = css`
  font-family: ${theme.fonts.default};
  font-weight: 700;
`;
